module.exports = __webpack_public_path__ + "media/images/icons/facebook-81df0a9a440503f39d80a183d66eee75.svg";